import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_DOCUMENT_PREVIEW,
  SOFTLINE_API_DOCUMENTS_PREVIEW,
} from '../documents.api';
import { mergePdfBase64 } from './merge-pdf-base64.function';
import {
  previewPayloadToBase64,
  previewPayloadToBase64List,
} from './preview-payload.function';

@Injectable()
export class DocumentPreviewRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  /** Print preview of one document (draft or finalized) as base64 PDF. */
  async load(id: string): Promise<string> {
    const payload = await this.dataAccess.create<unknown, unknown>(
      { path: SOFTLINE_API_DOCUMENT_PREVIEW, pathParams: { id } },
      {}
    );
    return previewPayloadToBase64(payload);
  }

  /** One merged PDF for several documents (the backend answers one PDF per id). */
  async loadMany(documentIds: string[]): Promise<string> {
    const payload = await this.dataAccess.create<string[], unknown>(
      { path: SOFTLINE_API_DOCUMENTS_PREVIEW },
      documentIds
    );
    return mergePdfBase64(previewPayloadToBase64List(payload));
  }
}
